(function() { window.GUID_9e2cea1d_2069_4e6a_83ef_a784637afc7c = { getGuid: function() { return "9e2cea1d-2069-4e6a-83ef-a784637afc7c"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Rendered({
                        selector: "body",
                        childSelector: ".accordion-games-v2",
                        callback: (accordion, e) => {
                            //const { isWallLayout } = GamesSection;
                            /*if (isWallLayout) {*/
                            WallSections.GamesSection.setObservers(accordion);
                            //GamesSection.appendFiltersCounterInTopBar();
                            //const $chips = accordion.$Content.find(".chips");
                            //if ($chips.length) {
                            //    //$chips.css({
                            //    //    top: `${Math.floor($("#section-top").outerHeight()) - 1}px`,
                            //    //});
                            //    $chips.removeClass("hiddenforced");
                            //}
                            const $allStickyHeaders = accordion.$Content.find(".item__header");
                            if ($allStickyHeaders.length) {
                                let top = CS.Views.MasterPage.TopHeight - 1;
                                const $filterChips = accordion.$Content.find(".filter-chips");
                                if ($filterChips.length) {
                                    top += $filterChips.outerHeight() - 1;
                                }
                                $allStickyHeaders.each((i, el) => {
                                    $(el).css({ top });
                                });
                            }
                            /*}*/
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=games-section.rendered.js.map
